module.exports = __webpack_public_path__ + "static/media/vitez_rider_app.8bf65045.png";